import type { MatchOffer } from 'types/MatchOffer';
import type { ResultsLeagueBlock } from 'types/ResultsLeagueBlock';

export function yyyymmddLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}${m}${day}`;
}

/** Group flat day feed into sport × region × league blocks for the results table. */
export function eventsToFeedBlocks(events: MatchOffer[]): ResultsLeagueBlock[] {
  const map = new Map<string, MatchOffer[]>();
  for (const e of events) {
    if (!e.league) continue;
    const sportId = e.league.sport;
    const region = String(
      (e.league as { league_group_name?: string }).league_group_name || ''
    ).trim();
    const lid = e.league.custom_id;
    const key = `${sportId}\u0000${region}\u0000${lid}`;
    const cur = map.get(key);
    if (cur) {
      cur.push(e);
    } else {
      map.set(key, [e]);
    }
  }
  const blocks: ResultsLeagueBlock[] = [];
  for (const [key, matches] of map) {
    const [sportIdStr, region, lidStr] = key.split('\u0000');
    const sportId = Number.parseInt(sportIdStr, 10);
    const leagueId = Number.parseInt(lidStr, 10);
    blocks.push({
      matches: matches.sort((a, b) => a.time - b.time),
      leagueId,
      sportId,
      groupLabel: region || null,
    });
  }
  blocks.sort((a, b) => {
    const na = a.matches[0]?.league?.name ?? '';
    const nb = b.matches[0]?.league?.name ?? '';
    if (a.sportId !== b.sportId) return a.sportId - b.sportId;
    const ga = String(a.groupLabel || '');
    const gb = String(b.groupLabel || '');
    if (ga !== gb) return ga.localeCompare(gb);
    return na.localeCompare(nb);
  });
  return blocks;
}
